$(document).ready(function(){

    $('#ajaxContactForm').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $form = $(this);
        var $submitBtn = $form.find('button[type="submit"]');
        var $responseBox = $form.find('.response-message');
        
        var originalBtnText = $submitBtn.text();
        $submitBtn.text('שולח...').prop('disabled', true);
        $responseBox.text('').removeClass('success error').css('color', '');

        $.ajax({
            type: 'POST',
            url: 'https://api.web3forms.com/submit',
            data: $form.serialize(),
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    $responseBox.text('תודה! ההודעה נשלחה בהצלחה.').addClass('success').css('color', 'green');
                    $form[0].reset();
                    
                    setTimeout(function() {
                        $responseBox.text(''); 
                    }, 3000);
                } else {
                    var msg = response.message || 'שגיאה בשליחה. אנא נסה שנית.';
                    $responseBox.text(msg).addClass('error').css('color', 'red');
                }
            },
            error: function(xhr) {
                $responseBox.text('שגיאת תקשורת. אנא נסה מאוחר יותר.').addClass('error').css('color', 'red');
            },
            complete: function() {
                $submitBtn.text(originalBtnText).prop('disabled', false);
            }
        });

        return false;
    });

});